import { MAX_BATCH_FILE_COUNT } from "../constants/limits";
import type {
  StorageErrorCode,
  UploadBatchItem,
  UploadCompleteResultItem,
} from "../types/project-storage.types";

export type PartitionedBatchItems = {
  ready: UploadBatchItem[];
  conflicts: UploadBatchItem[];
  errors: UploadBatchItem[];
};

export function partitionBatchItems(items: UploadBatchItem[]): PartitionedBatchItems {
  const ready: UploadBatchItem[] = [];
  const conflicts: UploadBatchItem[] = [];
  const errors: UploadBatchItem[] = [];

  for (const item of items) {
    switch (item.status) {
      case "ready_to_upload":
        ready.push(item);
        break;
      case "name_conflict":
        conflicts.push(item);
        break;
      default:
        errors.push(item);
        break;
    }
  }

  return { ready, conflicts, errors };
}

export function chunkArray<T>(
  items: T[],
  chunkSize = MAX_BATCH_FILE_COUNT
): T[][] {
  if (chunkSize <= 0) {
    throw new Error("chunkSize must be positive");
  }

  if (items.length === 0) {
    return [];
  }

  const chunks: T[][] = [];
  for (let index = 0; index < items.length; index += chunkSize) {
    chunks.push(items.slice(index, index + chunkSize));
  }

  return chunks;
}

export type CompleteResultMapping =
  | { ok: true }
  | { ok: false; errorCode: StorageErrorCode };

export function mapCompleteResult(
  result: UploadCompleteResultItem
): CompleteResultMapping {
  if (result.status === "uploaded") {
    return { ok: true };
  }

  return {
    ok: false,
    errorCode: result.errorCode ?? "FILE_NOT_FOUND_IN_STORAGE",
  };
}

export function isReadyForS3Put(item: UploadBatchItem): boolean {
  return (
    item.status === "ready_to_upload" &&
    item.fileId !== null &&
    item.presignedUrl !== null
  );
}
